import AccountContext from 'context/AccountContext';
import useShowPaymentCardStatus from 'hooks/useShowPaymentCardStatus';
import { useContext, useMemo } from 'react';
import { useUiStore } from 'stores/uiStore';
import { CardStatus } from 'types/generatedSchemaTypes';
import { getPaymentMethodsIndicator } from 'utils/indicatorUtils';
import {
  getCardExpiryDateText,
  getExpiringSoonCards,
} from 'utils/paymentUtils';
import PromotionCardExpiresSoon from '../PromotionCardExpiresSoon';
import { MenuSection } from './MenuComponents';

const CardExpiresMenu = () => {
  const {
    customer: { paymentCards },
  } = useContext(AccountContext);
  const indicators = useUiStore((state) => state.tabBarIndicators);

  const expiringSoonCards = paymentCards
    ? getExpiringSoonCards(paymentCards)
    : [];
  const paymentMethodsIndicator = useMemo(
    () => getPaymentMethodsIndicator(indicators),
    [indicators]
  );
  const { status, expYear, expMonth } = expiringSoonCards[0] || {};
  const { daysUntilExpiration } = useShowPaymentCardStatus(
    (status || 'Active') as CardStatus,
    expMonth || '',
    expYear || ''
  );
  const showExpiringSoonCardBanner = useMemo(
    () =>
      paymentMethodsIndicator?.indicatorNumber &&
      paymentMethodsIndicator?.indicatorNumber > 0 &&
      paymentMethodsIndicator.indicatorType === 'warning' &&
      daysUntilExpiration >= 0,
    [
      paymentMethodsIndicator?.indicatorNumber,
      paymentMethodsIndicator?.indicatorType,
      daysUntilExpiration,
    ]
  );
  return (
    <>
      {showExpiringSoonCardBanner && (
        <MenuSection noDivider>
          <PromotionCardExpiresSoon
            expiryDateText={getCardExpiryDateText(expMonth, expYear)}
          />
        </MenuSection>
      )}
    </>
  );
};

export default CardExpiresMenu;
